import React, { ChangeEvent, FormEvent } from 'react'
import { FormField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import { DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { LabeledValue } from 'antd/es/select'
import { CurrencyType } from 'api/Wallet/Types/Wallet'
import { Form } from 'formik'

interface CurrencyModalProps {
  currencies: LabeledValue[]
  currenciesMinDeposit: Record<CurrencyType, number>
  onChange(event: ChangeEvent<HTMLInputElement>, value: LabeledValue): void
  onSubmit(event: FormEvent): void
}

export const CampaignDetailsCurrencyModal: React.FC<CurrencyModalProps> = (props) => {
  const { currencies, currenciesMinDeposit, onChange, onSubmit } = props

  return (
    <Form onSubmit={onSubmit}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Currency Minimum Deposits</DialogTitle>
        </DialogHeader>
        {currencies.map((currency) => (
          <FormField
            key={currency.label as string}
            min={0}
            name={`currency-min-deposit-${currency.label}`}
            label={currency.label as string}
            type='number'
            value={currenciesMinDeposit[currency.label as CurrencyType]}
            onChange={(event) => onChange(event, currency)}
          />
        ))}
        <DialogFooter>
          <Button type='submit'>Submit</Button>
        </DialogFooter>
      </DialogContent>
    </Form>
  )
}
